import { Component } from '@angular/core';
import { SubmittedFormsListComponent } from '../../components/submitted-forms-list/submitted-forms-list.component';
import { AuthUserService } from '../../services/auth-user.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-review-forms',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SubmittedFormsListComponent,
  ],
  templateUrl: './review-forms.component.html',
  styleUrl: './review-forms.component.scss'
})
export class ReviewFormsComponent {

  constructor(public authUserService: AuthUserService) {
  }

  get userDisplayName() : String { return this.authUserService.displayName }
}
